import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, TreesIcon, InfoIcon } from 'lucide-react';
export function SchedulePricing() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-347">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-348">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12" data-id="element-349">
          {/* Schedule */}
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col" style={{
          borderColor: '#ede9e0'
        }} data-id="element-350">
            <div className="flex items-center gap-3 mb-6" data-id="element-351">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
              backgroundColor: 'rgba(200,168,75,0.15)'
            }} data-id="element-352">
                <CalendarDaysIcon size={20} style={{
                color: '#c8a84b'
              }} data-id="element-353" />
              </div>
              <h2 className="text-2xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-354">
                Schedule
              </h2>
            </div>

            <div className="space-y-4 flex-1" data-id="element-355">
              <div className="flex items-start gap-3" data-id="element-356">
                <TreesIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#4a7c59'
              }} data-id="element-357" />
                <p className="text-base" style={{
                color: '#2a2a2a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-358">
                  Targets are set up through the woods.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-359">
                <InfoIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                color: '#4a7c59'
              }} data-id="element-360" />
                <p className="text-base" style={{
                color: '#2a2a2a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-361">
                  3-D Shoots are open to the public. Please check the club
                  calendar for specific dates and times.
                </p>
              </div>
            </div>

            <Link to="/Calendar.html" className="mt-6 flex items-center justify-center gap-2 w-full py-3 px-4 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-362">
              <CalendarDaysIcon size={16} data-id="element-363" />
              View Club Calendar
            </Link>
          </div>

          {/* Pricing */}
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border flex flex-col" style={{
          borderColor: '#ede9e0'
        }} data-id="element-364">
            <div className="p-6" style={{
            backgroundColor: '#1e3d2f'
          }} data-id="element-365">
              <h2 className="text-2xl font-bold uppercase text-center" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-366">
                Course Fees
              </h2>
            </div>
            <div className="p-0 flex-1" data-id="element-367">
              <table className="w-full text-left border-collapse" data-id="element-368">
                <tbody data-id="element-369">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-370">
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#1a1a1a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-371">
                      Club Members
                    </td>
                    <td className="p-4 md:p-5 font-bold text-right" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-372">
                      $6
                    </td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-373">
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#1a1a1a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-374">
                      Non-Members
                    </td>
                    <td className="p-4 md:p-5 font-bold text-right" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-375">
                      $8
                    </td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-376">
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#1a1a1a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-377">
                      Youth (Age 13-17)
                    </td>
                    <td className="p-4 md:p-5 font-bold text-right" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-378">
                      $4
                    </td>
                  </tr>
                  <tr data-id="element-379">
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#1a1a1a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-380">
                      Kids (12 and under)
                    </td>
                    <td className="p-4 md:p-5 font-bold text-right" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-381">
                      Free
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}